import { DataBean } from "../DataBean";

export class TaxProcedureList extends DataBean {


    public async getTaxProcedureList(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTaxProcedureList_Number", [id]);
    }

}